import { render, staticRenderFns } from "./GeneralPlan.vue?vue&type=template&id=56ea79ac&scoped=true"
import script from "./GeneralPlan.vue?vue&type=script&lang=js"
export * from "./GeneralPlan.vue?vue&type=script&lang=js"
import style0 from "./GeneralPlan.vue?vue&type=style&index=0&id=56ea79ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea79ac",
  null
  
)

export default component.exports